import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingsReducerSelectors,
} from "redux/slices/v2/ListingReducer";
import Dropdown from "../DropDown/DropDown";
import classes from "./TransactionTypeSelect.module.scss";
import $ from "utils/selectors";

export default function TransactionTypeSelect({
  transactionType,
  onTransactionTypeChange,
  className,
  mapMobile = false,
}: {
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onTransactionTypeChange: (item: {
    value: string;
    vendu: boolean;
    label: string;
    color: string;
  }) => void;
  className?: any;
  mapMobile?: any;
}) {
  const { t } = useTranslation("commonAnnonces");
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );

  const TransactionOptions = [
    { value: "Vente", vendu: false, label: t("À vendre"), color: "#FF376E" },
    { value: "Location", vendu: false, label: t("À louer"), color: "#FFDC5A" },
    {
      value: "Projets Neufs",
      vendu: false,
      label: t("Projets Neufs"),
      color: "#B748D5",
    },
    { value: "Vente", vendu: true, label: t("Vendu"), color: "#00B4FF" },
  ];

  // const listingsSearchPayload = useSelector(
  //   ListingreducerSelectors.searchPayloadSelector
  // );

  const [typederecherche, setTypederecherche] = useState<
    "Vente" | "Location" | "Projets Neufs" | "Vendu" | ""
  >(transactionType);

  const [displayTypeDeRecherche, setDisplayTypeDeRecherche] =
    useState<boolean>(false);

  const [selectedOption, setSelectedOption] = useState(
    TransactionOptions.filter((item) => {
      return (
        item.value == transactionType &&
        item.vendu ==
        (searchPayload.vendu != undefined ? searchPayload.vendu : false)
      );
    })[0]
  );

  const dispatch = useDispatch();
  const [dropdownToggle, setDropdownToggle] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 990) {
      if (dropdownToggle) {
        $("#search_form_annonce").attr("style", `z-index : 0`);
      } else {
        $("#search_form_annonce").attr("style", `z-index : 10`);
      }
      $("body").css("height", "100%");
      $("body").css("overflow", "hidden");
    }
  }, [dropdownToggle]);
  const selectedOptionHandler = (item) => {
    setTypederecherche(item.value);
    onTransactionTypeChange(item);
    setDropdownToggle(false);
  };
  // useEffect(() => {
  //   if (searchPayload?.transaction_type) {
  //     setTypederecherche(searchPayload.transaction_type);
  //   }
  // }, [searchPayload]);
  // useEffect(() => {

  //   if (window.location.pathname.startsWith("/location")) {
  //     setTypederecherche("Location");
  //     setSelectedOption({
  //       value: "Location",
  //       label: t("À louer"),
  //       color: "#FFDC5A",
  //     });
  //   }
  //   if (window.location.pathname.startsWith("/achat")) {
  //     setTypederecherche("Vente");
  //     setSelectedOption({
  //       value: "Vente",
  //       label: t("À vendre"),
  //       color: "#FF376E",
  //     });
  //   }
  //   if (window.location.pathname.startsWith("/immobilier")) {
  //     setTypederecherche("Projets Neufs");
  //     setSelectedOption({
  //       value: "Projets Neufs",
  //       label: t("Projets Neufs"),
  //       color: "#B748D5",
  //     });
  //   }
  // }, []);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 425) setIsMobile(true);
      else setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 425) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  const contentComponent = (
    <ul style={{ padding: 0, margin: 0, height: "100%" }}>
      <div className={classes.transaction_type_style}>
        <div>
          <div className={classes.topBar_transaction_type}>
            <p className={classes.paragraph_type}>{t("Type de propriété")}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              className={classes.x_mark_margin}
              onClick={() => {
                dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
                setDropdownToggle(false);
              }}
            >
              <path
                d="M8.46954 6.94546L13.7595 1.65046C13.9234 1.45916 14.009 1.21308 13.9993 0.961404C13.9895 0.709728 13.8852 0.470988 13.7071 0.292894C13.529 0.114799 13.2903 0.0104669 13.0386 0.000745782C12.7869 -0.00897537 12.5408 0.0766307 12.3495 0.240457L7.05454 5.53046L1.75954 0.240457C1.56824 0.0766307 1.32217 -0.00897537 1.07049 0.000745782C0.818814 0.0104669 0.580075 0.114799 0.40198 0.292894C0.223886 0.470988 0.119553 0.709728 0.109832 0.961404C0.100111 1.21308 0.185717 1.45916 0.349544 1.65046L5.63954 6.94546L0.349544 12.2405C0.244862 12.3301 0.159841 12.4404 0.0998179 12.5645C0.0397946 12.6886 0.00606468 12.8237 0.000745182 12.9614C-0.00457431 13.0991 0.0186315 13.2365 0.0689061 13.3648C0.119181 13.4931 0.195439 13.6097 0.292893 13.7071C0.390348 13.8046 0.506896 13.8808 0.635221 13.9311C0.763546 13.9814 0.900878 14.0046 1.0386 13.9993C1.17632 13.9939 1.31145 13.9602 1.43551 13.9002C1.55958 13.8402 1.6699 13.7551 1.75954 13.6505L7.05454 8.36046L12.3495 13.6505C12.5408 13.8143 12.7869 13.8999 13.0386 13.8902C13.2903 13.8804 13.529 13.7761 13.7071 13.598C13.8852 13.4199 13.9895 13.1812 13.9993 12.9295C14.009 12.6778 13.9234 12.4318 13.7595 12.2405L8.46954 6.94546Z"
                fill="black"
              />
            </svg>
          </div>
          {TransactionOptions.map((item, idx) => (
            <div
              key={idx}
              className={classes.listItemWrapper}
              onClick={() => setSelectedOption(item)}
            >
              <span
                className={`${classes.selectedIcon} ${item.label === selectedOption?.label
                  ? classes.selectedIconActive
                  : classes.selectedIconInactive
                  }`}
              ></span>
              <li key={idx} className={classes.listItem}>
                <i
                  className="fas fa-circle"
                  style={
                    isMobile
                      ? {
                        fontSize: "13px",
                        color: item.color,
                        marginLeft: "0px",
                        marginRight: "6px",
                      }
                      : {
                        fontSize: "13px",
                        color: item.color,
                        marginRight: "6px",
                      }
                  }
                ></i>
                {item.label}
              </li>
            </div>
          ))}
        </div>
        <div className={classes.validBtnWrapper}>
          <span
            className={mapMobile ? classes.validBtnMAP : classes.validBtn}
            onClick={() => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              selectedOptionHandler(selectedOption);
            }}
          >
            {t("Valider")}
          </span>
        </div>
      </div>
    </ul>
  );

  return (
    <>
      <Dropdown
        t={t}
        liststyling={isMobile ? classes.listoverride : ""}
        className={className ? className : classes.buttonWrapper}
        contentComponent={contentComponent}
        valueComponent={
          <div className={classes.valueWrapper}>
            <span
              style={{
                minWidth: "8px",
                width: "8px",
                height: "8px",
                backgroundColor: selectedOption?.color,
                borderRadius: "50%",
              }}
            ></span>
            <span className={classes.dropdownLabel}>
              {t(selectedOption?.label)}
            </span>
          </div>
        }
        toggleBtnStyle={
          mapMobile ? classes.toggleBtnStyleMapMobile : classes.toggleBtnStyle
        }
        // onToggleActive={classes.toggleBtnActive}
        dropdownToggle={dropdownToggle}
        setDropdownToggle={(e) => {
          dispatch(ListingreducerActions.setDisplayMobileSearchBar(!e));
          setDropdownToggle(e);
        }}
        MapMobile={mapMobile}
      />
    </>
  );
}
